export function getKeyMomentsFormatsFromEvent(event) {
  return event?._keyMomentLinks?.map(keyMomentLink => keyMomentLink._keyMoment?.format) || [];
}